<!--
 * @Author: your name
 * @Date: 2021-01-27 09:20:49
 * @LastEditTime: 2021-01-28 08:57:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \archetype-Resources\src\app.vue
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      current:'1',
      screenWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
    };
  },
  created() {
    this.lastTime = new Date().getTime();
    this.fun();
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        (window.screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth),
          (that.screenWidth = window.screenWidth);
        this.fun();
      })();
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    }
  },
  methods: {
    // 设置html标签的字体大小自适应   为了使得rem单位自适应
    fun() {
      const that = this;
      let htmlObj = document.getElementsByTagName("html")[0];
      htmlObj.style.fontSize = (that.screenWidth / 1920) * 20 + "px";
    }
  }
}
</script>
<style lang="less">
@import './base.less';

html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: hidden;
  word-break: break-all;
  word-wrap: break-word;
}

#app {
  width: 100%;
  height: 100%;
}

//.ivu-select-dropdown {
//  ul {
//    max-width: 120px;
//    padding-top: 8px;
//    li {
//      width: 100%;
//      height: 100%;
//      overflow: hidden;
//      text-overflow: ellipsis;
//      white-space: nowrap; /**不换行**/
//      display: inline-block;
//    }
//  }
//}
</style>
